
var pf_config = require('./pf_config.json');

const canI = (user, team, feature, currentTeam) => {

  if(feature === undefined) return true;

  var useTeamRole = (user.isLoggedIn && team.cache[team.current] && currentTeam) ? true : false;

  var retval = false;

  let availability = pf_config.features[feature].availability;

  // Team role is broken out separately since this isn't on the roles object
  if(useTeamRole){
    retval = availability.teams;
  }

  // Loop through roles to see if you have one that applies
  // This should just be Open & Pro for now
  var roles = user.roles;

  if(!user.roles.enterpries && user.isLoggedIn) user.roles.open = true;

  if(!user.email_verified){
    delete roles.open;
  }

  roles.trial = true;

  let reasons = [];
  
  for(var i in roles){

    if(roles[i]){
      var v = availability[i];
      // If it's true, lets mark retval that at least one of your roles should give you access to this
      if(v > retval){
        retval = v;
      }
      if(v){
        reasons.push(i);
      }
    }
  }

  if(team.current && team.cache[team.current]){
    if((team.cache[team.current].delinquent || team.cache[team.current].subscription_ended || team.cache[team.current].overstaffed)){
      retval = availability['open'];
    }
  } else {
    if(reasons[0] == "pro" && user.delinquent){
      retval = availability['open'];
    }
  }

  // if(reasons.length === 1){
  //   if(reasons[0] == "pro" && user.delinquent && !team.current){
  //     return false;
  //   }
  //   if(reasons[0] == "teams" && team.current && team.cache[team.current].delinquent){
  //     return false;
  //   }
  // }
  return retval;
}

export default canI;


// WEBPACK FOOTER //
// ./src/canI.js